import script from "./CaseDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./CaseDetails.vue?vue&type=script&setup=true&lang=js"

import "./CaseDetails.vue?vue&type=style&index=0&id=7ae34847&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ae34847"]])

export default __exports__